import { useTranslation } from 'react-i18next';
import { TranslationKeys } from 'translations';
import { DrmPage } from 'v2/models';

interface Params {
  entityName: string;
  endpoint: string;
}

export function useDrmPageToParams() {
  const { t } = useTranslation();

  const drmPageToParams: Record<DrmPage, Params> = {
    [DrmPage.DATA_VENDOR]: {
      entityName: t(TranslationKeys.dataVendor_one),
      endpoint: 'data_vendor',
    },
    [DrmPage.CONTACT]: {
      entityName: t(TranslationKeys.contact_one),
      endpoint: 'contact',
    },
    [DrmPage.DATASET]: {
      entityName: t(TranslationKeys.dataProduct_one),
      endpoint: 'data_product',
    },
  };

  return drmPageToParams;
}
